// @format

const TOGGLE = "#bot_inbox_management";
const PICKER = "#bot_inbox_manager_ids";

function syncPicker(): void {
  const $toggle = $(TOGGLE);
  const $picker = $(PICKER);
  if (!$toggle.length || !$picker.length) return;

  const enabled = $toggle.is(":checked");

  $picker.prop("disabled", !enabled);

  // bootstrap-select renders its own button and wrapper. `refresh` updates the button,
  // but the wrapper keeps whatever `disabled` class it was built with -- and that class
  // is what greys the control out, so it has to be set by hand.
  if ($picker.data("selectpicker")) {
    $picker.selectpicker("refresh");
  }
  $picker.closest(".bootstrap-select").toggleClass("disabled", !enabled);
}

export function initInboxManagement(): void {
  if (!$(TOGGLE).length) return;

  $(document).off("change.inboxManagement").on("change.inboxManagement", TOGGLE, syncPicker);

  syncPicker();
}
